'use strict';

import $ from 'jquery';
import MessagesForDesktop from './MessagesForDesktop';

$(document).ready(() => {
  const app = new MessagesForDesktop();
  app.init();
});
